import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-anulacion',
  templateUrl: './modal-anulacion.component.html',
  styleUrls: ['./modal-anulacion.component.css']
})
export class ModalAnulacionComponent implements OnInit {

  constructor(
    private modalService: ModalService,
    private emit: EmitService
  ) { }

  ngOnInit(): void {
  }

  cerrar(){
    this.modalService.closeModal();
  }

  respuesta(resp: boolean){
    if (resp) {
      this.emit.enviarData('anular');
    } else {
      this.emit.enviarData('rellamar');
    }
    this.cerrar();
  }

}
